(() => {
  const SELECTOR = '[data-bb-gift-progress]';

  const formatMoney = (cents) => {
    return new Intl.NumberFormat('el-GR', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  };

  async function getCart() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${root}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to fetch Shopify cart');
    }

    return response.json();
  }

  function renderComponent(element, cart) {
    const threshold = parseInt(element.dataset.threshold || '10000', 10);

    const message = element.querySelector('[data-bb-gift-message]');
    const bar = element.querySelector('[data-bb-gift-bar]');
    const cta = element.querySelector('[data-bb-gift-cta]');

    /*
     * Χρησιμοποιούμε το Shopify cart total.
     * Το πραγματικό eligibility για το δώρο
     * το ελέγχει το Automatic Discount του Shopify.
     */
    const qualifyingTotal = cart.total_price;

    const remaining = Math.max(threshold - qualifyingTotal, 0);

    const percentage = Math.min(
      Math.max((qualifyingTotal / threshold) * 100, 0),
      100
    );

    if (bar) {
      bar.style.width = `${percentage}%`;
    }

    if (qualifyingTotal >= threshold) {
      element.classList.add('is-qualified');

      if (message) {
        message.innerHTML =
          '🎁 <strong>Το δώρο σου ξεκλειδώθηκε!</strong><br>Επίλεξε μία θήκη βιβλιαρίου.';
      }

      if (cta) {
        cta.hidden = false;
      }
    } else {
      element.classList.remove('is-qualified');

      if (message) {
        message.innerHTML =
          `🎁 Σου λείπουν <strong>${formatMoney(remaining)}</strong> για να πάρεις δώρο μία θήκη βιβλιαρίου.`;
      }

      if (cta) {
        cta.hidden = true;
      }
    }
  }

  async function refreshBabyBlueGift() {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) return;

    try {
      const cart = await getCart();

      elements.forEach((element) => {
        renderComponent(element, cart);
      });
    } catch (error) {
      console.warn('[BabyBlue Gift]', error);
    }
  }

  /*
   * Initial load
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshBabyBlueGift);
  } else {
    refreshBabyBlueGift();
  }

  /*
   * Common Shopify theme cart events
   */
  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'cart:update',
    'theme:cart:change'
  ].forEach((eventName) => {
    document.addEventListener(eventName, refreshBabyBlueGift);
  });

  /*
   * Το συγκεκριμένο theme κάνει AJAX replacements.
   * Παρακολουθούμε το cart drawer/cart page,
   * αλλά κάνουμε debounce ώστε να μη χτυπάει cart.js συνέχεια.
   */
  let mutationTimer;

  const observer = new MutationObserver((mutations) => {
    const relevantChange = mutations.some((mutation) => {
      return (
        mutation.target.closest?.(
          'cart-drawer, cart-items, [data-cart-page], [data-items-holder]'
        ) ||
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            (
              node.matches?.(
                'cart-drawer, cart-items, [data-cart-page], [data-items-holder]'
              ) ||
              node.querySelector?.(SELECTOR)
            )
        )
      );
    });

    if (!relevantChange) return;

    clearTimeout(mutationTimer);

    mutationTimer = setTimeout(() => {
      refreshBabyBlueGift();
    }, 150);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();